import { useState, type FormEvent } from 'react';
import { useDataset } from '../data/DatasetContext.tsx';

export function LoginPage() {
  const { login } = useDataset();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Login failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-4">
      <h1 className="text-lg font-semibold">Aviator Analytics</h1>
      <p className="mt-1 text-sm text-muted">Private historical analysis. Sign in to continue.</p>
      <form className="mt-6 space-y-3 rounded border border-line bg-panel p-4" onSubmit={(event) => void onSubmit(event)}>
        <label className="flex flex-col gap-1 text-sm">
          Username
          <input
            className="rounded border border-line bg-page px-2 py-2"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </label>
        <label className="flex flex-col gap-1 text-sm">
          Password
          <input
            className="rounded border border-line bg-page px-2 py-2"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error ? (
          <p className="text-sm text-warn" role="alert">
            {error}
          </p>
        ) : null}
        <button type="submit" className="w-full rounded bg-accent px-4 py-2 text-sm text-panel disabled:opacity-60" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
